.LoadingIndicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: var(--space-6xl);
    height: var(--space-6xl);
    animation: revvly-breathe 2.4s var(--rv-ease-in-out) infinite;

    /* the mint tile */
    & rect {
      fill: var(--rv-accent);
    }

    /* base waveform — the brand mark, always present */
    & path:nth-of-type(1) {
      stroke: var(--rv-accent-ink-deep);
    }

    /* a bright signal pulse running along the waveform */
    & path:nth-of-type(2) {
      stroke: var(--white);
      stroke-dasharray: 14 100;
      stroke-dashoffset: 114;
      animation: revvly-signal 1.6s linear infinite;
    }
  }
}

@keyframes revvly-signal {
  from {
    stroke-dashoffset: 114;
  }

  to {
    stroke-dashoffset: 0;
  }
}

@keyframes revvly-breathe {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}

@media (prefers-reduced-motion: reduce) {
  .LoadingIndicator svg {
    animation: none;
  }

  .LoadingIndicator svg path:nth-of-type(2) {
    animation: none;
    opacity: 0%;
  }
}
